/**
 * RecoverCann Age Gate
 * Verifies visitor age before allowing site access
 * Based on RecoverCann Swell implementation
 */

(function() {
  'use strict';

  const AGE_STORAGE_KEY = 'recovercann_age_verified';
  const EXPIRY_DAYS = 30; // localStorage expiry when "remember me" is checked

  class AgeGate {
    constructor() {
      this.overlay = document.getElementById('recovercann-age-gate');
      if (!this.overlay) return;

      this.yesButton = document.getElementById('age-gate-yes');
      this.noButton = document.getElementById('age-gate-no');
      this.rememberCheckbox = document.getElementById('age-gate-remember');

      // Ensure required elements exist before initializing
      if (!this.yesButton || !this.noButton) return;

      this.init();
    }

    init() {
      const hasLoginError = this.checkLoginError();

      // Check if already verified — unless a failed login just bounced us
      // back here, in which case the visitor needs to see the error and retry
      if (this.isVerified() && !hasLoginError) {
        this.overlay.style.display = 'none';
        return;
      }

      // Show age gate
      this.overlay.style.display = 'flex';

      // Yes button - verify and close
      this.yesButton.addEventListener('click', () => {
        this.verify();
      });

      // No button - redirect away
      this.noButton.addEventListener('click', () => {
        window.location.replace('https://google.ca');
      });
    }

    isVerified() {
      // Check the 30-day persistent flag first
      const stored = localStorage.getItem(AGE_STORAGE_KEY);
      if (stored) {
        try {
          const { timestamp } = JSON.parse(stored);
          const expiryTime = timestamp + (EXPIRY_DAYS * 24 * 60 * 60 * 1000);

          if (Date.now() <= expiryTime) {
            return true;
          }
          localStorage.removeItem(AGE_STORAGE_KEY);
        } catch (e) {
          localStorage.removeItem(AGE_STORAGE_KEY);
        }
      }

      // Fall back to session-only flag, for visitors who unchecked "remember me"
      return sessionStorage.getItem(AGE_STORAGE_KEY) === 'true';
    }

    verify() {
      const remember = this.rememberCheckbox ? this.rememberCheckbox.checked : true;

      if (remember) {
        localStorage.setItem(AGE_STORAGE_KEY, JSON.stringify({
          verified: true,
          timestamp: Date.now()
        }));
      } else {
        sessionStorage.setItem(AGE_STORAGE_KEY, 'true');
      }

      // Hide overlay
      this.overlay.style.display = 'none';

      // Let other components (e.g. the how-to popup) react to a fresh verification
      document.dispatchEvent(new CustomEvent('recovercann:age-verified'));
    }

    checkLoginError() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('login_error') !== '1') return false;

      const errorEl = document.getElementById('age-gate-login-error');
      if (errorEl) {
        errorEl.style.display = 'block';
      }

      // Clean up the URL
      urlParams.delete('login_error');
      const newUrl = urlParams.toString()
        ? window.location.pathname + '?' + urlParams.toString()
        : window.location.pathname;
      window.history.replaceState({}, '', newUrl);

      return true;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new AgeGate();
    });
  } else {
    new AgeGate();
  }
})();
